import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { MessageDisplayLoaderService } from "common/services/message-display-loader-service";
import { Subscription } from "rxjs";

@Component({
  selector: "message-display-loader",
  templateUrl: "./message-display-loader.component.html",
  styleUrls: ["./message-display-loader.component.scss"],
})
export class MessageDisplayLoaderComponent implements OnInit, OnDestroy {
  show = false;
  spinnerTexts: any;
  textPositions: any;
  message: string;
  @ViewChild("loader") loader: ElementRef<HTMLInputElement>;
  private subscriptionShowMessage: Subscription;
  private subscriptionMessage: Subscription;
  constructor(private messageDisplayService: MessageDisplayLoaderService) {}

  ngOnInit() {
    this.subscriptionShowMessage =
      this.messageDisplayService.showMessageObs.subscribe((value) => {
        this.show = value;
      });
    this.subscriptionMessage = this.messageDisplayService.messageObs.subscribe(
      (value) => {
        this.message = value;
        this.initializeLoaderTexts();
      }
    );
  }

  ngOnDestroy() {
    this.subscriptionMessage.unsubscribe();
    this.subscriptionShowMessage.unsubscribe();
  }

  ngAfterViewInit() {
    this.spinnerTexts = this.loader.nativeElement.querySelectorAll(
      '[class^="message-loader-spinner-text-"]'
    );
    this.textPositions = [0, 1];
    this.initializeLoaderTexts();
  }

  initializeLoaderTexts() {
    if (this.spinnerTexts && this.spinnerTexts.length > 0 && this.message) {
      this.spinnerTexts.forEach((spinnerText, index) => {
        spinnerText.innerText = this.message;
        spinnerText.addEventListener("animationiteration", (e) => {
          e.target.innerText = this.message;
        });
      });
    }
  }
}
